import { AppointmentTableRow } from './TableRow';

interface AppointmentsTableProps {
  rows: any;
  /** ID of the appointment currently being confirmed, or null when idle. */
  confirmingId: string | null;
  onConfirm: (id: string) => void;
}

const HEADER_CELL =
  'text-left text-[11px] font-semibold text-secondary-400 uppercase tracking-wider px-3 py-3 whitespace-nowrap';

export const AppointmentsTable = ({ rows, confirmingId, onConfirm }: AppointmentsTableProps) => (
  <div className="w-full overflow-x-auto">
    <table className="w-full min-w-[860px]">
      <thead>
        <tr>
          <th className={`${HEADER_CELL} w-10`}>#</th>
          <th className={HEADER_CELL}>Provider</th>
          <th className={HEADER_CELL}>Date</th>
          <th className={HEADER_CELL}>Time</th>
          <th className={HEADER_CELL}>Type</th>
          <th className={HEADER_CELL}>Status</th>
          <th className={HEADER_CELL}>Confirmation</th>
          <th className={HEADER_CELL}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <AppointmentTableRow
            key={`appointment-${row.id}`}
            row={row}
            index={i}
            confirmingId={confirmingId}
            onConfirm={onConfirm}
          />
        ))}
      </tbody>
    </table>
  </div>
);
